// ** Redux Imports
import { createSlice } from "@reduxjs/toolkit"

// ** ThemeConfig Import
import themeConfig from "@configs/themeConfig"

const initialMenuCollapsed = () => {
  const item = window.localStorage.getItem("menuCollapsed")
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : themeConfig.layout.menu.isCollapsed
}

const initialDirection = () => {
  const item = window.localStorage.getItem("direction")
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : themeConfig.layout.isRTL
}

const initialSkin = () => {
  const item = window.localStorage.getItem("skin")
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : themeConfig.layout.skin
}

const initialState = {
  skin: initialSkin(),
  isRTL: initialDirection(),
  layout: themeConfig.layout.type,
  lastLayout: themeConfig.layout.type,
  menuCollapsed: initialMenuCollapsed(),
  footerType: themeConfig.layout.footer.type,
  navbarType: themeConfig.layout.navbar.type,
  menuHidden: themeConfig.layout.menu.isHidden,
  contentWidth: themeConfig.layout.contentWidth,
  routerTransition: themeConfig.layout.routerTransition,
  navbarColor: themeConfig.layout.navbar.backgroundColor
}
export const layout = {
  state: initialState,
  reducers: {
    /**
     *
     * @param {*} state
     * @param {*} value
     * @returns
     */
    handleRTL: (state, value) => {
      const isRtl =
        typeof value === "boolean"
          ? value
          : value && typeof value.payload === "boolean"
            ? value.payload
            : !!value?.payload
      window.localStorage.setItem("direction", JSON.stringify(isRtl))
      return {
        ...state,
        isRTL: isRtl
      }
    },
    /**
     *
     * @param {*} state
     * @param {*} value
     * @returns
     */
    handleSkin: (state, value) => {
      window.localStorage.setItem("skin", JSON.stringify(value))
      return {
        ...state,
        skin: value
      }
    },
    /**
     *
     * @param {*} state
     * @param {*} value
     * @returns
     */
    handleLayout: (state, value) => {
      return {
        ...state,
        layout: value
      }
    },
    /**
     *
     * @param {*} state
     * @param {*} value
     * @returns
     */
    handleFooterType: (state, value) => {
      return {
        ...state,
        footerType: value
      }
    },
    /**
     *
     * @param {*} state
     * @param {*} value
     * @returns
     */
    handleNavbarType: (state, value) => {
      return {
        ...state,
        navbarType: value
      }
    },
    handleMenuHidden: (state, value) => {
      return {
        ...state,
        menuHidden: value
      }
    },
    handleLastLayout: (state, value) => {
      return {
        ...state,
        lastLayout: value
      }
    },
    handleNavbarColor: (state, value) => {
      return {
        ...state,
        navbarColor: value
      }
    },
    handleContentWidth: (state, value) => {
      return {
        ...state,
        contentWidth: value
      }
    },
    handleMenuCollapsed: (state, value) => {
      window.localStorage.setItem("menuCollapsed", JSON.stringify(value))
      return {
        ...state,
        menuCollapsed: value
      }
    },
    handleRouterTransition: (state, value) => {
      return {
        ...state,
        routerTransition: value
      }
    }
  },
  effects: (dispatch) => ({
    /**
     *
     * @param {*} value
     */
    onHandleRtl(value) {
      this.handleRTL(value)
    },
    /**
     *
     * @param {*} value
     */
    onHandleSkin(value) {
      this.handleSkin(value)
    },
    /**
     *
     * @param {*} value
     */
    onHandleLayout(value) {
      this.handleLayout(value)
    },
    /**
     *
     * @param {*} value
     */
    onHandleFooterType(value) {
      this.handleFooterType(value)
    },
    /**
     *
     * @param {*} value
     */
    onHandleNavbarType(value) {
      this.handleNavbarType(value)
    },
    /**
     *
     * @param {*} value
     */
    onHandleMenuHidden(value) {
      this.handleMenuHidden(value)
    },
    /**
     *
     * @param {*} value
     */
    onHandleLastLayout(value) {
      this.handleLastLayout(value)
    },
    /**
     *
     * @param {*} value
     */
    onHandleNavbarColor(value) {
      this.handleNavbarColor(value)
    },
    /**
     *
     * @param {*} value
     */
    onHandleContentWidth(value) {
      this.handleContentWidth(value)
    },
    /**
     *
     * @param {*} value
     */
    onHandleMenuCollapsed(value) {
      this.handleMenuCollapsed(value)
    },
    /**
     *
     * @param {*} value
     */
    onHandleRouterTransition(value) {
      this.handleRouterTransition(value)
    }
  })
}

// export const {
//   handleRTL,
//   handleSkin,
//   handleLayout,
//   handleLastLayout,
//   handleMenuHidden,
//   handleNavbarType,
//   handleFooterType,
//   handleNavbarColor,
//   handleContentWidth,
//   handleMenuCollapsed,
//   handleRouterTransition,
// } = layoutSlice.actions;

// export default layoutSlice.reducer;
